import stub from "stubs/footer";

const footerResolver = (data = stub) => {
  return data;
};

export default footerResolver;
